import React from 'react';
import LeftArrowIcon from '@usas/ui-web/components/icons/LeftArrowIcon';
import useBackToSystemLink from './UseBackToSystemLink';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const BackToSystemLink = () => {
  const { label, onBackToSelectionClicked } = useBackToSystemLink();

  return (
    <button className={global.BackToSearchButton}
      type="button"
      onClick={onBackToSelectionClicked}>
      <LeftArrowIcon />  {label}
    </button>
  );
};

export default BackToSystemLink;